








































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useThemeStore } from "@/shared/store/theme";
import { Validator } from "vee-validate";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class RecommendedThresholdForm extends Vue {

  @Prop({ required: true }) isLoaded: boolean;

  drivewealthStore = useDrivewealthStore();
  notifierStore = useNotifierStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();

  formatCurrency = formatCurrency;
  $validator: Validator;
  thresholdModalOpen = false;
  customThreshold = 0;
  recommendedThresholdSelected = true;


  get hasPreviousSweepActivity (): boolean {
    return (this.drivewealthSweepStore.sweepIsActive || this.drivewealthSweepStore.sweepWasActive);
  }
  get recommendedThresholdButtonVariant (): string {
    return this.recommendedThresholdSelected ? "primary" : "secondary";
  }

  get customThresholdButtonVariant (): string {
    return this.recommendedThresholdSelected ? "secondary" : "primary";
  }

  get recommendedThreshold (): number {
    return this.investmentThresholdStore.sweepThreshold;
  }

  saveCustomThreshold (): void {
    this.drivewealthSweepStore.setInvestmentThreshold(this.customThreshold);
    this.recommendedThresholdSelected = false;
    this.drivewealthSweepStore.setIsRecommendedThreshold(false);
    this.hideThresholdModal();
  }

  get isSaveCustomThresholdDisabled (): boolean {
    return this.customThreshold < this.drivewealthStore.hsaInvestmentThreshold || this.errors.any();
  }

  setThresholdToDefaultValue (): void {
    this.recommendedThresholdSelected = true;
    this.drivewealthSweepStore.setIsRecommendedThreshold(true);
    this.drivewealthSweepStore.setInvestmentThreshold(this.recommendedThreshold);
  }

  displayThresholdModal (): void {
    this.thresholdModalOpen = true;
  }

  cancelThresholdModal (): void {
    this.customThreshold = this.threshold;
    this.hideThresholdModal();
  }

  hideThresholdModal (): void {
    this.thresholdModalOpen = false;
  }

  get threshold (): number {
    return this.drivewealthSweepStore.investmentThreshold;
  }

  set threshold (value: number) {
    this.drivewealthSweepStore.setInvestmentThreshold(value);
  }

  get sweepIsActive (): boolean {
    return this.drivewealthSweepStore.sweepIsActive;
  }

  get thresholdSetToEmployerPartnerDefault (): boolean {
    return this.drivewealthStore.hsaInvestmentThreshold === this.threshold;
  }

  @Watch("isLoaded")
  setCustomThresholdInitialValue (newValue): void {
    if (newValue === true) {
      if (this.hasPreviousSweepActivity) {
        this.recommendedThresholdSelected = this.drivewealthSweepStore.isRecommendedThreshold;
        this.customThreshold = this.threshold;
      } else {
        this.recommendedThresholdSelected = true;
        this.customThreshold = this.recommendedThreshold;
        this.drivewealthSweepStore.setIsRecommendedThreshold(true);
        this.drivewealthSweepStore.setInvestmentThreshold(this.recommendedThreshold);
      }
    }
  }

  get thresholdValidator (): { required: boolean, decimal: number, min_value_usd: number } {
    return {
      required: true,
      decimal: 2,
      min_value_usd: this.drivewealthStore.hsaInvestmentThreshold
    };
  }

}
